import { httpClient } from '../api/http-client';

export interface MigracionResponse {
  mode: string;
  status: string;
  resumen: {
    totalPedidos: number;
    pedidosNuevos: number;
    pedidosHistoricos: number;
    pedidosMixtos: number;
    totalLotes: number;
    itemsProcesados: number;
    updatesPlanificados: number;
    actualizados: number;
    advertencias: number;
    noAsignados: number;
    diferenciasStock: number;
  };
  advertencias: string[];
  noAsignados?: string[];
  diferenciasStock: Array<{
    loteId: string;
    virtual: number;
    bd: number;
    diff: number;
  }>;
  muestraUpdates: Array<{
    itemId: string;
    loteId: string;
    precioCompra: number;
    pedidoId: string;
  }>;
  aplicado: boolean;
}

export interface CrearLotesResponse {
  mode: string;
  status: string;
  mensaje?: string;
  resumen: {
    productosSinLotes: number;
    lotesPlanificados: number;
    lotesCreados: number;
    errores: number;
  };
  errores: string[];
  muestra: Array<{
    producto: string;
    presentacion: string;
    cantidad: number;
    costoUnitario: number | null;
  }>;
  aplicado: boolean;
}

export class MaintenanceService {
  static async migrarLotes(
    adminKey: string,
    apply: boolean = false,
  ): Promise<MigracionResponse> {
    const response = await httpClient.post<MigracionResponse>(
      `/api/migrar-lotes${apply ? '?apply=true' : ''}`,
      {},
      {
        headers: {
          'X-Admin-Key': adminKey,
        },
      },
    );
    return response.data;
  }

  static async crearLotesStock(
    adminKey: string,
    apply: boolean = false,
  ): Promise<CrearLotesResponse> {
    const response = await httpClient.post<CrearLotesResponse>(
      `/api/crear-lotes-stock${apply ? '?apply=true' : ''}`,
      {},
      {
        headers: {
          'X-Admin-Key': adminKey,
        },
      },
    );
    return response.data;
  }
}
